import { ActiveWidgets } from 'modules/Editor/store/widgetControlSlice';
import { WidgetId } from 'types/idTypes';
import { WidgetType } from 'types/widget.types';

import { MULTI_WIDGET_TOOLBAR_CONFIG } from '../../../Widget.config';
import { getWidgetTypeFromId } from '../../../Widget.helpers';
import { MultiEditOption, MultiEditWidgetTypes } from '../../../Widget.types';

/**
 * Takes the active widgets and returns a list with widget ids (widgets that support multi editing)
 * Considers group members as well
 *
 * @param activeWidgets - the active widgets
 */
const getAllMultiEditWidgetIds = (activeWidgets: ActiveWidgets) => {
  let allIds: WidgetId[] = [];

  for (let i = 0; i < activeWidgets.length; i++) {
    const activeWidget = activeWidgets[i];

    const type = getWidgetTypeFromId(activeWidget.id);
    const isMultiEditWidget = MULTI_WIDGET_TOOLBAR_CONFIG[type as MultiEditWidgetTypes];

    // if the widget is a multi edit widget, add it to the list of ids
    if (isMultiEditWidget && !allIds.includes(activeWidget.id)) {
      allIds.push(activeWidget.id);
    }
  }

  return allIds;
};

/**
 * Get the multi-edit toolbar options from the active widgets
 * @param activeWidgets
 *
 * returns MultiEditOption[]
 */
const getToolbarOptions = (activeWidgets: ActiveWidgets) => {
  const options: MultiEditOption[] = [];
  const widgetIds = getAllMultiEditWidgetIds(activeWidgets);
  const typeMap: { [key in WidgetType]?: boolean } = {};

  for (let i = 0; i < widgetIds.length; i++) {
    const widgetType = getWidgetTypeFromId(widgetIds[i]);

    // if we've already added the options for this widget type, continue
    if (typeMap[widgetType]) continue;

    typeMap[widgetType] = true;
    const widgetOptions = MULTI_WIDGET_TOOLBAR_CONFIG[widgetType as MultiEditWidgetTypes];

    // non-text should always be first
    if (widgetType !== WidgetType.Text) {
      options.unshift(...widgetOptions);
      continue;
    }

    options.push(...widgetOptions);
  }

  // only return unique options
  return [...new Set(options)];
};

export { getAllMultiEditWidgetIds, getToolbarOptions };
